<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;">
      <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
               :items="items" :fields="fields">
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(place)="data" style="'left':'80px';">
          {{ data.item.meterAttribute==='1'? data.item.installationSite:data.item.houseName}}
        </template>
        <template v-slot:cell(meterAttribute)="data" style="'left':'80px';">
          {{data.item.meterAttribute==1?'不计费':data.item.meterAttribute==2?'计费预充值':'计费非预充值' }}
        </template>
        <template v-slot:cell(times)="data" style="'left':'80px';">
          {{ Number(data.item.times).toFixed(0) }}
        </template>
        <template v-slot:cell(prevReading)="data" style="'left':'80px';">
          {{Number(data.item.prevReading).toFixed(data.item.decimalPlaces) }}
        </template>
        <template v-slot:cell(lastReading)="data" style="'left':'80px';">
          {{Number(data.item.lastReading).toFixed(data.item.decimalPlaces) }}
        </template>
        <template v-slot:cell(lastQuantity)="data" style="'left':'80px';">
          {{data.item.lastQuantity?Number(data.item.lastQuantity).toFixed(data.item.decimalPlaces):'-' }}
        </template>
        <template v-slot:cell(feeItemName)="data" style="'left':'80px';">
          {{data.item.feeItemName?data.item.feeItemName:'-'}}
        </template>
        <template v-slot:cell(feeNormName)="data" style="'left':'80px';">
          {{data.item.feeNormName?data.item.feeNormName:'-'}}
        </template>
        <template v-slot:cell(amount)="data" style="'left':'80px';">
          {{data.item.amount||data.item.amount==0?data.item.amount:'-'}}
        </template>
        <template v-slot:cell(paymentAmount)="data" style="'left':'80px';">
          {{data.item.paymentAmount||data.item.paymentAmount==0?data.item.paymentAmount:'-'}}
        </template>
        <template v-slot:cell(stayAmount)="data" style="'left':'80px';">
          {{data.item.stayAmount||data.item.stayAmount==0?data.item.stayAmount:'-'}}
        </template>
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'materialData' ? '120px' : field.key === 'index' ?'30px':'80px',left: field.key === 'materialData' ? '120px' : '80px'}"
          />
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import {BTable} from 'bootstrap-vue'


export default {
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'place', stickyColumn: true, label: '安装地点'},
        {key: 'bunkCode', label: '铺位信息'},
        {key: 'meterNumber', label: '管理编码'},
        {key: 'meterName', label: '计量表名称'},
        {key: 'meterAttribute', label: '计量表属性'},
        {key: 'measuringRange', label: '量程'},
        {key: 'times', label: '倍率'},
        {key: 'prevReadingDate', label: '上次抄表日期'},
        {key: 'prevReading', label: '上次抄表读数'},
        {key: 'lastReadingDate', label: '本次抄表日期'},
        {key: 'lastReading', label: '本次抄表读数'},
        {key: 'lastQuantity', label: '用量'},
        {key: 'feeItemName', label: '收费项目名称'},
        {key: 'feeNormName', label: '收费标准名称'},
        {key: 'paymentAmount', label: '实收金额'},
        {key: 'stayAmount', label: '待收金额'},
      ],
      items: [],
      layoutHeight: '0px',
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      this.items = query.data.meters
    });
  },
  methods: {
    init() {
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style>
tr th:nth-child(2), tr td:nth-child(2) {
  left: 30px !important;
}
</style>
